<template>
  <div id="game-container" ref="gameContainer"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import Phaser from 'phaser'
import { gameConfig } from './game/config'

const gameContainer = ref<HTMLDivElement>()
let game: Phaser.Game | null = null

onMounted(() => {
  game = new Phaser.Game({
    ...gameConfig,
    parent: gameContainer.value!,
  })
})

onUnmounted(() => {
  game?.destroy(true)
})
</script>

<style>
html, body, #app, #game-container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #1a1a2e;
}
</style>
